import BaseModel from "./_BaseModel";

export default class Invoice extends BaseModel {
    public readonly ucode?: string;
    public no_transaksi?: string;
    public tanggal_transaksi?: string;
    public nama_customer?: string;
    public nopol?: string;

    public constructor(
        ucode?: string
    ) {
        super();
        this.ucode = ucode;
    }
};
